import CoreBalance from 'core/js/pages/municipality-data/balance/index.js'
import AccountMediaPanel from './account/_account_media_panel'
import tscMediaPanel from './tsc/_tsc_media_panel'

export default CoreBalance.extend({
  components: {
    ...CoreBalance.options.components,
    AccountMediaPanel,
    tscMediaPanel
  }
})
